import React from 'react'
import Svg, { Path, SvgProps } from 'react-native-svg'

import { useTheme } from 'styled-components/native'

import { tID } from '../../utils/utils'

/**
 * Calendar with a cross through it, used to represent cancelled sessions.
 */
export const CalendarCancelIcon = ({ size = 24, fillColor, ...rest }: CalendarCancelIconProps & SvgProps) => {
  const { colors } = useTheme()

  return (
    <Svg width={size} height={size} viewBox='-3 -2 24 24' fill='none' testID={tID('CalendarCancelIcon')} {...rest}>
      <Path
        d='M16 2H15V0H13V2H5V0H3V2H2C0.9 2 0 2.9 0 4V18C0 19.1 0.9 20 2 20H16C17.1 20 18 19.1 18 18V4C18 2.9 17.1 2 16 2ZM16 18H2V8H16V18ZM2 6V4H16V6H2ZM5.23 15.41L6.29 16.47L8.73 14.03L11.17 16.47L12.23 15.41L9.79 12.97L12.23 10.53L11.17 9.47L8.73 11.91L6.29 9.47L5.23 10.53L7.67 12.97L5.23 15.41Z'
        fill={fillColor || colors.iconDefault}
      />
    </Svg>
  )
}

export type CalendarCancelIconProps = {
  size?: number
  fillColor?: string
}
